import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Row } from "reactstrap";
import zithasLogo from "../../../assets/images/zithas-p.png";
import { fetchNodeData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import Loader from "pages/Separate/Loader";
import moment from "moment";
import { hnsOptions } from "utils/common-options";
import { numberToWords } from "utils/common-helpers";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import JsPDF, { jsPDF } from "jspdf";
import html2pdf from "html2pdf.js";
import Swal from "sweetalert2";
import EmailInvoiceModal from "./EmailInvoiceModal";

const ZithasInvoiceView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [isLoading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [emailModal, setEmailModal] = useState(false);
  const token = secureLocalStorage.getItem("auth_token");
  useEffect(() => window.scrollTo(0, 0), []);
  const contentRef = useRef(null);

  document.title = "New Invoice | Zithas Crm";

  useEffect(() => {
    const getInvoiceDetail = async () => {
      const res = await fetchNodeData(
        setLoading,
        `zithasInvoice/${params?.id}`,
      );
      if (res?.status == 200) {
        setInvoiceData(res?.data);
        if (location.state?.openEmail) setEmailModal(true);
      }
    };
    getInvoiceDetail();
  }, []);

  const reactToPrintFn = useReactToPrint({
    contentRef,
  });

  // const onDownloadInvoice = () => {
  //   setLoading(true)
  //   const content = contentRef.current

  //   const opt = {
  //     filename: `${invoiceData?.invoice_number}.pdf`,
  //     image: { type: "jpeg", quality: 0.98 },
  //     html2canvas: { dpi: 192, letterRendering: true, scale: 2 },
  //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //   }

  //   setTimeout(() => setLoading(false), 2000)
  //   html2pdf().from(content).set(opt).save()
  // }

  const onDownloadInvoice = () => {
    setLoading(true); // 1) trigger loader

    setTimeout(() => {
      // 2) allow one render tick
      try {
        const content = contentRef.current;
        if (!content) {
          throw new Error("Invoice content is not ready yet");
        }

        const invoiceNumber = invoiceData?.invoice_number || "invoice";
        const safeFileName =
          invoiceData?.balance_due > 0
            ? invoiceNumber.replace(/\//g, "-")
            : invoiceNumber.replace("-PRF", "").replace(/\//g, "-");

        const opt = {
          filename: `${safeFileName}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 192, letterRendering: true, scale: 2 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        };

        html2pdf()
          .from(content)
          .set(opt)
          .save()
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Download Failed",
              text: err?.message || String(err),
            });
          })
          .finally(() => setLoading(false)); // 3) hide loader after complete
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Download Failed",
          text: err?.message || String(err),
        });
        setLoading(false);
      }
    }, 150);
  };
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className={"page-content mb-4"}>
        <Container fluid>
          <Row>
            <div className="col-md-9 ps-0 d-flex justify-content-center">
              <div id="zithasInvoicePrint" className="col-md-11 p-3 document">
                <div className="invoice-view p-4 bg-white " ref={contentRef}>
                  <div className="row justify-content-between">
                    <div className="col-4">
                      <img
                        src={zithasLogo}
                        className="img-fluid mt-2 w-100"
                        alt=""
                      />
                    </div>

                    <div className="col-4 text-end">
                      <span>
                        ZITHAS <br />
                        FF-16 Kalpvrux Complex,
                        <br />
                        Opp. GEB Substation, Gotri Road <br />
                        Vadodara Gujarat 390021 India
                        {/* <br /> GSTIN 24AABCZ2004K1ZL */}
                      </span>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-4 pe-0">
                      <div className="invoice-line"></div>
                    </div>
                    <div className="col-4">
                      <p className="fs-4 py-3 text-center bg-white mb-0 fw-bold">
                        INVOICE
                      </p>
                    </div>
                    <div className="col-4 ps-0">
                      <div className="invoice-line"></div>
                    </div>
                  </div>

                  <div className="row justify-content-between">
                    <div className="col-4 ">
                      <p className="mb-0">Bill To</p>
                      <p className="mb-0">{invoiceData?.c_company} ,</p>
                      {/* <p className="mb-0">
                        {invoiceData?.c_address}, {invoiceData?.city_name},
                      </p> */}
                      <p className="mb-0">
                        {invoiceData?.c_address},
                        {invoiceData?.city_name
                          ? ` ${invoiceData.city_name}, `
                          : ""}
                      </p>
                      <p className="mb-0">
                        {invoiceData?.state_name}, {invoiceData?.country_name} -{" "}
                        {invoiceData?.c_zipcode}
                      </p>
                      {/* <p className="mb-0">GST : {invoiceData?.c_vatnumber}</p> */}
                    </div>
                    <div className="col-4 ps-0">
                      <table
                        className="table w-100"
                        style={{ fontSize: "x-small" }}
                      >
                        <tbody>
                          <tr>
                            <th className="border border-secondary py-1">
                              Invoice#
                            </th>
                            <td className="border border-secondary py-1">
                              {invoiceData?.invoice_number}
                            </td>
                          </tr>
                          <tr>
                            <th className="border border-secondary py-1">
                              Invoice Date
                            </th>
                            <td className="border border-secondary py-1">
                              {moment(invoiceData?.invoice_date).format(
                                "DD-MM-YYYY",
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th className="border border-secondary py-1">
                              Terms
                            </th>
                            <td className="border border-secondary py-1">
                              {invoiceData?.terms}
                            </td>
                          </tr>
                          <tr>
                            <th className="border border-secondary py-1">
                              Due Date
                            </th>
                            <td className="border border-secondary py-1">
                              {moment(invoiceData?.due_date).format(
                                "DD-MM-YYYY",
                              )}
                            </td>
                          </tr>
                          {moment(invoiceData?.start_date)?.isValid() ? (
                            <tr>
                              <th className="border border-secondary py-1">
                                Start Date
                              </th>
                              <td className="border border-secondary py-1">
                                {moment(invoiceData?.start_date).format(
                                  "DD-MM-YYYY",
                                )}
                              </td>
                            </tr>
                          ) : null}
                          {moment(invoiceData?.end_date)?.isValid() ? (
                            <tr>
                              <th className="border border-secondary py-1">
                                End Date
                              </th>
                              <td className="border border-secondary py-1">
                                {moment(invoiceData?.end_date).format(
                                  "DD-MM-YYYY",
                                )}
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="mt-2">
                    <table className="table w-100">
                      <thead>
                        <tr>
                          <th className="border border-secondary">#</th>
                          <th className="border border-secondary">
                            Item & Description
                          </th>
                          <th className="border border-secondary">HSN/SAC</th>
                          <th className="border border-secondary">Qty</th>
                          <th className="border border-secondary" style={{ width: "15%" }}>Rate</th>
                          <th className="border border-secondary" style={{ width: "15%" }}>Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {invoiceData?.items?.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td className="border border-secondary">
                                {i + 1}
                              </td>
                              <td className="border border-secondary">
                                <div className="">{obj?.project_name}</div>
                                <div className="">{obj?.service}</div>
                                <span>{obj?.service_detail}</span>
                              </td>
                              <td className="border border-secondary">
                                {/* {
                                  hnsOptions?.find(
                                    opt => opt?.value == obj?.hsn
                                  )?.label
                                } */}
                                {obj.hsn}
                              </td>
                              <td className="border border-secondary">
                                {obj?.quantity}
                              </td>
                              <td className="border border-secondary">
                                {invoiceData?.currency_symbol} {obj?.rate}
                              </td>
                              <td className="border border-secondary">
                                {invoiceData?.currency_symbol}{" "}
                                {Number(obj?.rate) * Number(obj?.quantity)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: invoiceData?.customer_note,
                      }}
                    />
                  </div>

                  <div className="row justify-content-end">
                    <div className="col-5">
                      <div className="d-flex py-1 justify-content-between">
                        <span>Sub Total</span>
                        <span>
                          {invoiceData?.currency_symbol}{" "}
                          {invoiceData?.sub_total}
                        </span>
                      </div>
                      <div className="d-flex py-1 justify-content-between">
                        <span>Discount</span>
                        <span>{invoiceData?.currency_symbol}{" "}{invoiceData?.discount_amount || 0}</span>
                      </div>
                      <div className="d-flex pt-2 border-top border-secondary pb-2 justify-content-between">
                        <strong> Total ({invoiceData?.currency_symbol})</strong>
                        <span>
                          {invoiceData?.currency_symbol}
                          {(
                            Math.floor(
                              parseFloat(invoiceData?.total || 0) * 100,
                            ) / 100
                          ).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className=" row">
                    <p>
                      Total in Words :{" "}
                      <strong>
                        {numberToWords(
                          (
                            Math.floor(
                              parseFloat(invoiceData?.total || 0) * 100,
                            ) / 100
                          ).toFixed(2) || 0,
                          invoiceData?.currency_name,
                        )}
                      </strong>
                    </p>

                    <div className="d-flex justify-content-between">
                      {/* LEFT SIDE */}
                      <div className="col-6 pe-4 border-end border-2 ">
                        <h4 className="fw-bold">Bank Details</h4>

                        <table className="table">
                          <tr>
                            <th>Bank Name :</th>
                            <td>HDFC Bank Ltd.</td>
                          </tr>
                          <tr>
                            <th>Branch Name :</th>
                            <td>KARELIBAUG</td>
                          </tr>
                          <tr>
                            <th>Account Name :</th>
                            <td>Zithas</td>
                          </tr>
                          <tr>
                            <th>Account No. :</th>
                            <td>50200006048052</td>
                          </tr>
                          <tr>
                            <th>IFSC Code :</th>
                            <td>HDFC0000147</td>
                          </tr>
                        </table>
                      </div>

                      {/* RIGHT SIDE */}
                      <div className="col-6 ps-4">
                        <h4 className="fw-bold">Terms &amp; Conditions</h4>
                        <p className="mb-1 fs-6">
                          1. If payment made by crossed cheque in favour of
                          Zithas.
                        </p>
                        <p className="mb-1 fs-6">
                          2. NEFT / RTGS / Online Transfer should be made to the
                          given bank details.
                        </p>
                        <p className="mb-0 fs-6">
                          3. Late payment charges will be applicable.
                        </p>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-4 pe-0 ">
              <div>
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    className="btn btn-sm btn-success border-radius flex-fill text-nowrap"
                    onClick={() => reactToPrintFn()}
                    disabled={invoiceData?.approve == 0}
                  >
                    <i className="fas fa-print me-1"></i> Print
                  </button>

                  <button
                    className="btn btn-sm btn-secondary border-radius flex-fill text-nowrap"
                    onClick={() => onDownloadInvoice()}
                    disabled={invoiceData?.approve == 0}
                  >
                    <i className="fas fa-file-download me-1"></i> Download
                  </button>

                  <button
                    className="btn btn-sm btn-purple border-radius flex-fill text-nowrap"
                    onClick={() => setEmailModal(true)}
                    disabled={invoiceData?.approve == 0}
                  >
                    <i className="fas fa-envelope me-1"></i> Email
                  </button>

                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-sm btn-red border-radius flex-fill text-nowrap"
                  >
                    <i className="fas fa-times fs-6 me-1"></i> Cancel
                  </button>
                </div>

                <div className="bg-white p-3 mt-4 shadow">
                  <h5 className="mb-4 text-dark">
                    Invoice Value : {invoiceData?.currency_symbol}{" "}
                    {(
                      Math.floor(parseFloat(invoiceData?.total || 0) * 100) /
                      100
                    ).toFixed(2)}
                  </h5>

                  <h6 className="mb-3">
                    Invoice Number: {invoiceData?.invoice_number}
                  </h6>
                  {moment(invoiceData?.start_date)?.isValid() ? (
                    <h6 className="mb-3">
                      Start Date:{" "}
                      {moment(invoiceData?.start_date).format("DD-MM-YYYY")}
                    </h6>
                  ) : null}
                  {moment(invoiceData?.end_date)?.isValid() ? (
                    <h6 className="mb-3">
                      End Date:{" "}
                      {moment(invoiceData?.end_date).format("DD-MM-YYYY")}
                    </h6>
                  ) : null}
                  <h6 className="mb-3">
                    Due Date:{" "}
                    {moment(invoiceData?.due_date).format("DD-MM-YYYY")}
                  </h6>
                  {invoiceData?.exchange_rate ? (
                    <div className="pt-3 mt-1 border-top">
                      <h6 className="mb-2 text-danger">
                        Exchange Rate :{" "}
                        <span className="fw-normal">
                          1 {invoiceData.currency_symbol} = ₹{" "}
                          {Number(invoiceData.exchange_rate).toFixed(2)}
                        </span>
                      </h6>
                      <h6 className="mb-0 fw-bold">
                        Total (₹) :{" "}
                        <span className="fw-normal">
                          ₹{" "}
                          {(
                            parseFloat(invoiceData.total || 0) *
                            parseFloat(invoiceData.exchange_rate)
                          ).toFixed(2)}
                        </span>
                      </h6>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </div>
      <EmailInvoiceModal
        isOpen={emailModal}
        toggle={() => setEmailModal(false)}
        invoiceNumber={invoiceData?.invoice_number}
        customerId={invoiceData?.customer_id}
        companyLabel="Zithas"
        contentRef={contentRef}
      />
    </React.Fragment>
  );
};

export default ZithasInvoiceView;
